import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["ImageComponent"] */ "/app/src/components/Image/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StaticPage"] */ "/app/src/components/StaticPage/index.tsx");
